<template>
	<div id="cs-anon-action" class="cs-anon-action-container">
		<div class="cs-anon-action-output">
			<div
				class="cs-anon-action-logo cs-bg-primary"
				v-html="logo"
				aria-hidden="true"
			></div>
			<div class="cs-anon-action-body cs-bg-white">
				<p>{{ (requestFailed) ? 'Thank you for attempting to complete this request.' : 'Thank you for submitting your request.' }}</p>
				<div v-if="actionInProgress" class="cs-anon-action-loading">
					<cs-loading-logo />
				</div>
				<div v-else>
					<span :class="{ 'cs-fg-danger' : (showActionButton && actionUrl) }">{{ actionResultMessage }}</span>
					<div v-if="showActionButton && actionUrl">
						<a :href="actionUrl" aria-label="Go to action"  class="cs-button cs-bg-primary cs-fg-white cs-anon-action-link mt-4">Sign in</a>
					</div>
				</div>
			</div>
		</div>		
	</div>
</template>
<script type="text/javascript">
import MiComponentBase from '@/js/mixins/mi-componentBase';

/**
 * Anonymous action component
 *
 * @format
 */

export default {
	name: 'CsAnonymousAction',

	mixins: [
		MiComponentBase
	],

	components: {
		'cs-loading-logo': () => import(/* webpackChunkName: "../global/cs-loadinglogo" */ '../global/cs-loadinglogo')
	},

	props: {
		/**
		 * Required prop as this is a router view. always an empty object
		 */
		screen: {
			type: Object,
			required: false,
			default: () => {}
		},

		/**
		 * Required prop as this is a router view, always 0
		 */
		inPageComponentEditVersion: {
			type: Number,
			required: false,
			default: 0
		}
	},

	data() {
		return {
			logo: null,
			actionInProgress: true,
			actionResultMessage: null,
			showActionButton: false,
			requestFailed: false
		}
	},

	mounted() {
		// We're clearing app loading overlay when screen component finished loading
		this.$loadSVG('/dist/images/corestream-logo-colour.svg').then(response => {
			this.logo = response;
		})
		.catch(error => {
			console.log(error);
		});
		this.$hideAppLoadingOverlay();
		this.initialiseRequest();
	},

	methods: {
		/**
		 * @public
		 * @description
		 * Initialises the request to the controller, if the variables are available
		 * 
		 */
		initialiseRequest() {
			let token = this.$route.params.token,
				formId = this.$route.params.formid,
				buttonId = this.$route.params.buttonid;

			if (token && formId && buttonId) {
				this.$axios.post(`${this.$getApiBaseUrl()}/api/TokenController/Execute/${token}/${formId}/${buttonId}`)
				.then(response => {
					if (response.status === 200) {
						if (typeof response.data.status === 'string' && (response.data.status.toLowerCase() === 'token expired' || response.data.status.toLowerCase() === 'token already used')) {
							this.actionResultMessage = 'Your request could not be completed. This could be because it has already been completed, or that your temporary access period has expired. To sign in and complete the request manually, please use the button below.';
							this.requestFailed = true;
						} else {
							this.actionResultMessage = 'Request completed. To sign in, please use the button below. Alternatively, you may close this window.';
						}
					} else {
						this.actionResultMessage = 'Your request could not be completed. This could be because it has already been completed, or that your temporary access period has expired. To sign in and complete the request manually, please use the button below.';
						this.requestFailed = true;
					}
					this.showActionButton = true;
				})
				.catch(error => {
					this.actionResultMessage = 'Your request could not be completed. This could be because it has already been completed, or that your temporary access period has expired. To sign in and complete the request manually, please use the button below.'
					this.showActionButton = true;
					this.requestFailed = true;
					this.$recordError({
						type: 'error',
						error: error,
						errorMessage: 'Sorry, we could not carry out this action, please contact support',
						displayToUser: true,
						errorCode: '000340'
					});
				})
				.finally(() => {
					this.actionInProgress = false;
				});			
			}
		}
	},

	computed: {
		/**
		 * @public
		 * @description
		 * Grabs the action url from the main window url 
		 * if it is available and returns it
		 * 
		 * @returns {Mixed}
		 */
		actionUrl() {
			let actionUrl = null;

			if (this.requestFailed) {
				if (this.$route.query && this.$route.query.url) {
					actionUrl = this.$route.query.url;
				}
			} else {
				actionUrl = '/';
			}

			return actionUrl;
		}
	}
};
</script>
<style lang="scss">
.cs-app.anonymousAction {
	.cs-container {
		padding: 0;
	}
}

.cs-anon-action-container {
	display: flex;
	height: 100%;
	align-items: center;
	justify-content: center;

	.cs-anon-action-output {
		flex: 1 1 auto;
		max-width: 600px;
		border-radius: $cs-border-radius;
		@include cs-shadow-4dp();
		overflow: hidden;
	}

	.cs-anon-action-body {
		padding: $cs-standard-pad;
		text-align: center;
	}
}

.cs-anon-action-logo {
	height: 53px;
	width: auto;
	text-align: center;
	padding: $cs-standard-pad 0;

	img,
	svg {
		height: 100%;
		width: auto;
		max-width: 100%;
	}

	.cs-logo-large {
		display: none;
	}

	@include media-breakpoint-up(md) {
		.cs-logo-small {
			display: none;
		}

		.cs-logo-large {
			display: inline;
		}
	}
}

.cs-anon-action-link:hover {
	text-decoration: none;
}
</style>
